import { toast } from "sonner";
import { supabase } from "@/lib/supabase";
import { setLastSigninEmail } from "@/lib/lastEmail";

export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const handleLogin = async (email: string): Promise<boolean> => {
  const trimmed = email.trim();
  if (!EMAIL_REGEX.test(trimmed)) {
    toast.error("Adresse email invalide.");
    return false;
  }

  const { error } = await supabase.auth.signInWithOtp({
    email: trimmed,
    options: { emailRedirectTo: window.location.origin },
  });

  if (error) {
    console.error("Supabase signInWithOtp failed:", error);
    toast.error(`Échec de l'envoi du lien : ${error.message}`);
    return false;
  }

  // Memoise l'email pour : (1) pre-remplissage prochaine connexion,
  // (2) auto-recovery sur SIGNED_OUT involontaire (Safari ITP, etc.).
  // Cf. client/src/lib/lastEmail.ts.
  void setLastSigninEmail(trimmed);

  toast.success(`Un lien de connexion a été envoyé à ${trimmed}.`);
  return true;
};
